import { Link } from 'react-router-dom';
import { FaLinkedinIn, FaFacebookF, FaInstagram } from 'react-icons/fa';

import { footerNav } from '../../data/navigation';
import {
  company,
  publishedRegistration,
  publishedCertifications,
} from '../../data/company';
import logoWhite from '../../assets/img/bethel-logo-white.png';
import './footer.css';

const SOCIAL_ICONS = {
  LinkedIn: FaLinkedinIn,
  Facebook: FaFacebookF,
  Instagram: FaInstagram,
};

const Footer = () => {
  const year = new Date().getFullYear();
  const registration = publishedRegistration();
  const certifications = publishedCertifications();

  return (
    <footer className="site-footer on-navy">
      <div className="container">
        <div className="site-footer__top">
          {/* ---- Brand column ---- */}
          <div className="site-footer__brand">
            {/* Reversed artwork — the previous footer used the .jpg, which has
                no alpha channel and rendered as a white box on the dark ground. */}
            <img src={logoWhite} alt="Bethel Innovations" width="1057" height="236" />
            <p className="site-footer__blurb">
              A small business delivering cybersecurity, AI governance,
              quantum readiness and enterprise IT services to government, government
              contractors and nonprofit organizations.
            </p>
            <ul className="site-footer__social">
              {company.social.map(({ name, href }) => {
                const Icon = SOCIAL_ICONS[name];
                return (
                  <li key={name}>
                    <a
                      href={href}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={`Bethel Innovations on ${name} (opens in a new tab)`}
                    >
                      <Icon aria-hidden="true" focusable="false" />
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* ---- Navigation columns ---- */}
          {footerNav.map((group) => (
            <nav key={group.heading} className="site-footer__col" aria-label={group.heading}>
              <h2 className="site-footer__heading">{group.heading}</h2>
              <ul className="site-footer__links">
                {group.links.map((link) => (
                  <li key={link.to}>
                    {/* react-router <Link>, not <a href> — the previous footer
                        forced a full page reload on every internal link. */}
                    <Link to={link.to}>{link.label}</Link>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          {/* ---- Contact column ---- */}
          <div className="site-footer__col">
            <h2 className="site-footer__heading">Contact</h2>
            <ul className="site-footer__links">
              <li>
                <a href={company.contact.phoneHref}>{company.contact.phone}</a>
              </li>
              <li>
                <a href={company.contact.emailHref}>{company.contact.email}</a>
              </li>
              {company.contact.address && (
                <li>
                  <address>{company.contact.address}</address>
                </li>
              )}
              <li className="site-footer__hours">{company.contact.hours}</li>
            </ul>
          </div>
        </div>

        {/* ---- Federal credentials strip ------------------------------------
             Renders only the values the client has verified. Everything in
             company.js that is still null stays off the site entirely.
             ------------------------------------------------------------------ */}
        {(registration.length > 0 ||
          company.naics.length > 0 ||
          certifications.length > 0) && (
          <div className="site-footer__credentials">
            {company.naics.length > 0 && (
              <div className="credential">
                <span className="credential__label">NAICS</span>
                <span className="credential__value tabular">
                  {company.naics.map((n) => n.code).join(' · ')}
                </span>
              </div>
            )}
            {registration.map((field) => (
              <div className="credential" key={field.label}>
                <span className="credential__label">{field.label}</span>
                <span className="credential__value tabular">{field.value}</span>
              </div>
            ))}
            {certifications.map((cert) => (
              <div className="credential" key={cert.name}>
                <span className="credential__label">Status</span>
                <span className="credential__value">{cert.name}</span>
              </div>
            ))}
          </div>
        )}

        <div className="site-footer__bottom">
          <p>
            © {year} {company.legalName}. All rights reserved.
          </p>
          <ul className="site-footer__meta">
            <li>
              <Link to="/capability-statement">Capability Statement</Link>
            </li>
            <li>
              <Link to="/accessibility">Accessibility</Link>
            </li>
          </ul>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
